export const useDrawerState = (
  initialVisibility?: boolean
) => {
  const isVisible = ref(initialVisibility ?? false)

  const showDrawer = () => {
    isVisible.value = true
  }

  const hideDrawer = () => {
    isVisible.value = false
  }

  return {
    isVisible,
    showDrawer,
    hideDrawer,
  }
}
